<script>
	import Router from '../../States/Router';
	import Conference from '../../States/Conference';
	import Helper from '../../Models/Helper';
	import Sidebar from '../Sidebar.svelte';

	Conference.subscribe((state) => {
		// setTimeout(() => {
		// 	window.$('[data-bs-toggle]').popover();
		// }, 800);
	})

	function goToConference(conferenceId, conferenceName, contacts, pickup) {
		let contact = contacts.length ? contacts[0] : false;
		let params = {id: conferenceId, contactId: contact.id, show: true, active: true};
		if(pickup) params = {contact: true, pickup: true, contactId: contact.id, conferenceName};
		Router.component('conference', params);
	}


</script>

<style>
	.participants {
		display: grid;
		column-gap: .5em;
		grid-template-columns: 50% 50%;
	}

	.participant {
		display: grid;
		grid-template-columns: 25% auto;
		align-items: center;
	}
	.conference-info {
		float: right;
    	margin: 0;
	}

	.card {
		cursor: pointer;
	}
</style>

<div class="container-fluid">
	<div class="wrapper">
		<Sidebar/>
		<div class="content-page">
			<div class="content">
				<div class="row">
					<div class="col-12">
						<div class="page-title-box">
							<h4 class="page-title">Conferences</h4>
						</div>
					</div>
				</div>

				<div class="row">
					{#if $Conference?.list?.incoming && $Conference?.list?.incoming?.length}
						<div>
							<h4>Incoming</h4>
							{#each $Conference.list.incoming as item, index}
								<div class="col-md-3">
									<div class="card" on:click={() => goToConference(item.id, false, item.contacts, true)}>
										<div class="card-body">
											<h4 class="header-title mb-3">Conference {index +1}</h4>
											<div class="participants">
												{#each item.agents as agent}
													{#if agent.status != 'participant-leave'}
														<div class="participant">
															<div class="round-name" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-content="{agent.name}">{agent.initials}</div>
															<div class="name">{agent.name}</div>
														</div>
													{/if}
												{/each}
												{#each item.contacts as contact}
													{#if contact.status != 'participant-leave'}
														<div class="participant">
															<div class="round-name" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-content="{contact.name}">{contact.initials}</div>
															<div class="name">{contact.name}</div>
														</div>
													{/if}
												{/each}
											</div>
											<div class="mt-2">
												<button class="btn btn-success btn-sm" on:click={goToConference(false, item.name, item.contacts, true)}><i class='uil uil-incoming-call me-1'></i>Answer</button>
												<p class="conference-info text-muted mt-1 font-14">Active for: <strong>{Helper.secondsToMinutes(item.duration)} for minutes</strong></p>
											</div>
										</div>
									</div>
								</div>
							{/each}
						</div>
					{/if}
					{#if $Conference?.list?.active && $Conference?.list?.active?.length}
						<div>
							<h4>Active</h4>
							{#each $Conference.list.active as item, index}
								<div class="col-md-3">
									<div class="card" on:click={() => goToConference(item.id, false, item.contacts, false)}>
										<div class="card-body">
											<h4 class="header-title mb-3">Conference {index +1}</h4>
											<div class="participants">
												{#each item.agents as agent}
													{#if agent.status != 'participant-leave'}
													<div class="participant">
														<div class="round-name" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-content="{agent.name}">{agent.initials}</div>
														<div class="name">{agent.name}</div>
													</div>
													{/if}
												{/each}
												{#each item.contacts as contact}
													{#if contact.status != 'participant-leave'}
														<div class="participant">
															<div class="round-name" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-content="{contact.name}">{contact.initials}</div>
															<div class="name">{contact.name} {#if contact.blocked}<span class="badge bg-danger rounded-pill">Blocked</span>{/if}</div>
														</div>
													{/if}
												{/each}
											</div>
											<p class="conference-info text-muted mt-2 font-14">Active for: <strong>{Helper.secondsToMinutes(item.duration)} minute(s)</strong></p>
										</div>
									</div>
								</div>
							{/each}
						</div>
					{/if}
					<!-- <div class="col-md-3">
						<div class="card">
							<div class="card-body">
								<h4 class="header-title mb-3">Conference 2</h4>
								<div class="participants">
									<div class="round-name" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-content="Matijs van Rijn">MVR</div>
									<div class="round-name" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-content="Anton">A</div>
								</div>
								<p class="conference-info text-muted mt-2 font-14">Active for: <strong>20:23 minutes</strong></p>
							</div>
						</div>
					</div> -->
				</div>
			</div>
		</div>
	</div>
</div>